import React, { LegacyRef, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/pro-regular-svg-icons";
import Input from "../../Input";
import Button from "../../../button/Button";

interface IProps {
    error?: boolean | undefined;
    success?: boolean | undefined;
    filedtitle?: React.ReactNode | undefined;
    help?: React.ReactNode | undefined;
    postchildren?: React.ReactNode | undefined;
    prechildren?: React.ReactNode | undefined;
}

const InputPassword = React.forwardRef(
    (
        props: IProps & React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
        ref: LegacyRef<HTMLInputElement>,
    ) => {
        const [value, setValue] = useState("");
        const [show, setShow] = useState<boolean>(false);

        return (
            <Input
                value={value}
                type={show ? "text" : "password"}
                {...props}
                ref={ref as any}
                insidepostchildren={
                    <Button variant="secondary" iconOnly onClick={(e) => setShow(!show)}>
                        <FontAwesomeIcon icon={show ? faEyeSlash : faEye} />
                    </Button>
                }
            />
        );
    },
);
export default InputPassword;
